import React, { Fragment } from 'react';
import '../../Hero/Hero.scss';
import { IProductsState, IState } from '../../../types/store/reducer';
import { useSelector } from 'react-redux';
import ContentWithPrice from './ContentWithPrice';
import { withContent } from '../../../hoc/withContext';
import { IContent } from '../../../types';
import './SubscriptionPrice.scss'


interface ISubscriptionPrice {
  context?: IContent;
}

const SubscriptionPrice = ({ context }: ISubscriptionPrice) => {
  let products: IProductsState = useSelector((state: IState) => state.products);
  let promoStartDate = new Date (context.hero.promo_start).getTime()
  let promoEndDate = new Date (context.hero.promo_end).getTime()
  let currentDate = new Date().getTime()

  let isPromoActive = currentDate >= promoStartDate && promoEndDate >= currentDate;
  return (
    <>
      {products.data.length !== 0 && (
        <>
          {(products.data[0].discountPercentage !== 0 && isPromoActive ) ?
            <Fragment>
              <ContentWithPrice
                id={context.uplayplus_productId}
                contentWrapper={context.hero.hero_discount_price}
                Tag={'p'}
                isDiscount={true}
                isDiscountItem={true}
              />
              <ContentWithPrice
                id={context.uplayplus_productId}
                contentWrapper={context.hero.hero_price_before_promo}
                Tag={'p'}
                isDiscount={true}
              />
            </Fragment> :
            <Fragment>
              <ContentWithPrice
                id={context.uplayplus_productId}
                contentWrapper={context.hero.hero_regular_price}
                Tag={'p'}
              />
            </Fragment>
          }
        </>
      )}
    </>
  );
};

export default withContent(SubscriptionPrice);